import { ContentTypeJson, POST_METHOD } from "../requst-methods";

const fetchFollowProduct = async ({
	followUrl,
	followingRequestBody,
	method,
}) => {

	const response = await fetch(followUrl, {
		method: method,
		headers: {
			...ContentTypeJson,
		},
		body: JSON.stringify(followingRequestBody),
	});

	if (response.ok) {
		return response.json();
	} else {
		console.error(
			`[INTERACTIVE PRODUCTS] Failed to follow product ${productId}`
		);
	}
};

export const followProduct = async ({ followUrl, followingRequestBody }) => {
	if (followUrl === undefined) {
		// Handlované přes catch
		throw new Error("Can't follow product. Follow URL is not defined.");
	}

	const response = await fetchFollowProduct({
		followUrl,
		followingRequestBody,
		method: POST_METHOD,
	});

	return response;
};
